import { Injectable, Inject } from '@angular/core';
import {
  LogPublisher,
  LogConsole,
  LogLocalStorage,
  LogWebApi,
  LogPublisherConfig
} from '../entities';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PUBLISHERS_FILE_CONFIGURATION_TOKEN } from '../tokens';

@Injectable({
  providedIn: 'root'
})
export class LogPublishersService {
  publishers: LogPublisher[] = [];
  path: string;

  constructor(
    @Inject(PUBLISHERS_FILE_CONFIGURATION_TOKEN) configuration: string,
    private http: HttpClient
  ) {
    this.path = configuration;
    this.buildPublishers();
  }

  buildPublishers(): void {
    let logPub: LogPublisher;

    this.getLoggers().subscribe(response => {
      response
        .filter(p => p.isActive)
        .forEach(pub => {
          switch (pub.loggerName.toLowerCase()) {
            case `console`:
              logPub = new LogConsole();
              break;
            case `localstorage`:
              logPub = new LogLocalStorage();
              break;
            case `webapi`:
              logPub = new LogWebApi(this.http);
              break;
          }

          // Set location, if any, of the logging
          logPub.location = pub.loggerLocation;

          // Add publisherto array
          this.publishers.push(logPub);
        });
    });
  }

  getLoggers(): Observable<LogPublisherConfig[]> {
    return this.http.get(this.path).pipe(
      map(data => data),
      catchError(this.handleErrors)
    );
  }

  private handleErrors(error: any): Observable<any> {
    console.log(error);
    const errors: string[] = [];
    let msg = `Status: ${error.Status} - Status Text: ${error.statusText}`;
    if (error) {
      msg += ` - Exception Message: ${error.exceptionMessage}`;
    }

    errors.push(msg);

    console.log('An error occured', errors);

    return throwError(errors);
  }
}
